"use client";

import { Spinner, SpinnerProps } from "reactstrap";

export default function SpinnerLoaderNew({
  className = "",
  ...props
}: SpinnerProps & {
  className?: string;
}) {
  return (
    <div className="spinner-new-style-container">
      <Spinner
        {...props}
        className={`spinner-new-style-v2 ${className}`}
      ></Spinner>
    </div>
  );
}
